import { axiosInstance as api } from "../helpers/request";
export interface UploadCancellation {
  state: "cancelled";
  releasePending: boolean;
  releaseAfter: string | null;
}
export interface UploadReceipt {
  intentId: string;
  requestKey: string;
  key: string;
  state: string;
  mediaId: string | null;
  releasePending: boolean;
  releaseAfter: string | null;
  heartbeatAt?: string | null;
}
export const UploadApi = {
  lookup: (streamId: string, requestKey: string) =>
    api.request<UploadReceipt>({
      method: "GET",
      url: `/streams/${streamId}/uploads`,
      params: { requestKey },
    }),
  heartbeat: (streamId: string, intentId: string) =>
    api.request<{ expiresAt: string }>({
      method: "POST",
      url: `/streams/${streamId}/uploads/${intentId}/heartbeat`,
    }),
  cancel: (streamId: string, intentId: string) =>
    api.request<UploadCancellation>({
      method: "POST",
      url: `/streams/${streamId}/uploads/${intentId}/cancel`,
    }),
  get: (streamId: string, intentId: string) =>
    api.request<UploadReceipt>({
      method: "GET",
      url: `/streams/${streamId}/uploads/${intentId}`,
    }),
};
